import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const STATUS_TINT = {
  draft: "bg-bg-elevated text-ink-muted",
  approved: "bg-sky-500/15 text-sky-300",
  published: "bg-emerald-500/15 text-emerald-300",
  archived: "bg-bg-elevated text-ink-muted line-through",
};

export const StoryRow = ({ s }) => (
  <Link
    to="/dashboard/news" data-testid={`newsroom-story-${s.story_id}`}
    className="group block rounded-xl border border-line bg-bg-surface p-4 transition hover:border-brand-amber/50"
  >
    <div className="flex items-center gap-2 mb-1.5 flex-wrap">
      {s.breaking && (
        <span className="rounded-full bg-rose-500/20 border border-rose-500/50 px-2 py-0.5 text-[9px] font-mono uppercase tracking-wider text-rose-300 animate-pulse">
          Breaking
        </span>
      )}
      {(s.genres?.[0] || s.category) && (
        <span className="rounded-full bg-brand-amber/15 px-2 py-0.5 text-[9px] font-mono uppercase tracking-wider text-brand-amber">
          {s.genres?.[0] || s.category}
        </span>
      )}
      <span className={`rounded-full px-2 py-0.5 text-[9px] font-mono uppercase tracking-wider ${STATUS_TINT[s.status] || STATUS_TINT.draft}`}>
        {s.status || "draft"}
      </span>
      <span className="text-[10px] text-ink-muted">{s.source}</span>
      <ChevronRight className="h-3.5 w-3.5 text-ink-muted ml-auto opacity-0 group-hover:opacity-100 transition" />
    </div>
    <div className="text-sm font-semibold text-ink-primary leading-snug">{s.headline}</div>
    {s.summary && <div className="mt-1 text-xs text-ink-secondary line-clamp-2">{s.summary}</div>}
  </Link>
);
